<template>

    <!-- <aside id="sidebar" class="sidebar" style="background-color: #4683B5;"> -->
    <aside id="mySidebar" class="sidebar" style="background-color: #4683B5;">

        <ul class="sidebar-nav" id="sidebar-nav">

            <li class="nav-item">
                <router-link class="nav-link" to="/" :class="{ collapsed: !$route.path.match(/^\/$/) }">
                    <i class="bi bi-grid-fill"></i>
                    <span>Inicio</span>
                </router-link>
            </li>

            <li class="nav-item" v-if="validatePermission('view_users')">
                <router-link class="nav-link" to="/Users" :class="{ collapsed: !$route.path.startsWith('/Users') }">
                    <i class="bi bi-person-fill"></i>
                    <span>Usuarios</span>
                </router-link>
            </li>

            <li class="nav-item" v-if="validatePermission('view_roles')">
                <router-link class="nav-link" to="/Roles" :class="{ collapsed: !$route.path.startsWith('/Roles') }">
                    <i class="bi bi-shield-lock-fill"></i>
                    <span>Roles</span>
                </router-link>
            </li>

            <!-- Sección de Aplicativos -->
            <li class="nav-item">
                <a class="nav-link collapsed" href="#" @click.prevent="toggleCollapse('apps-nav')"
                    :class="{ collapsed: isCollapsed('apps-nav') }">
                    <i class="bi bi-menu-app-fill"></i>
                    <span>Aplicaciones</span>
                    <i class="bi bi-chevron-down ms-auto" :class="{ rotated: !isCollapsed('apps-nav') }"></i>
                </a>
                
                <ul id="apps-nav" class="nav-content collapse list-unstyled" data-bs-parent="#sidebar-nav">
                    <li v-if="validatePermission('app_1')">
                        <router-link 
                            to="/Apps/App1"
                            :class="{ collapsed: !$route.path.startsWith('/Apps/App1') }"
                            class="d-flex align-items-center text-white"
                            >
                            <img :src="circularico" alt="circular" class="icon-img me-2" />
                            <span>Columnas en sección compuesta Circular</span>
                        </router-link>
                    </li>
                    <li v-if="validatePermission('app_2')">
                        <router-link to="/Apps/App2" :class="{ collapsed: !$route.path.startsWith('/Apps/App2') }" class="d-flex align-items-center text-white">
                        <img :src="rectangularico" alt="circular" class="icon-img me-2" />
                        <span>Columnas en sección compuesta Rectangular</span>
                        </router-link>
                    </li>
                </ul>
            </li>

        </ul>
    </aside>

</template>

<script>

import accountMixin from '@/mixins/accountMixin';
import { Collapse } from 'bootstrap';
import { eventBus } from '@/event-bus';

export default {
    name: 'Sidebar',

    mixins: [accountMixin,],

    data() {

        return {

            circularico: require('@/assets/images/circularico.png'),
            rectangularico: require('@/assets/images/rectangularico.png'),
            
            collapseInstances: {}, // Almacena instancias de Collapse

            isCollapsedState: {
                'apps-nav': true,
            },
        };
    },

    created() {

        eventBus.on('toggle-sidebar', this.setSidebar);
    },

    mounted() {
        this.initializeCollapse();

        // Sincroniza el estado del sidebar con la clase del body si ya existe
        if (window.innerWidth >= 1200 && document.body.classList.contains('toggle-sidebar')) {
            this.sidebarOpen = false;
        }
    },

    methods: {

        setSidebar(isOpen) {

            if (isOpen) {

                document.body.classList.remove('toggle-sidebar');

            } else {

                document.body.classList.add('toggle-sidebar');
            }
        },

        initializeCollapse() {
            // Asegúrate de que las instancias de colapso se ajusten a su estado inicial
            document.querySelectorAll(".nav-content").forEach((el) => {
                this.collapseInstances[el.id] = new Collapse(el, {
                    toggle: false
                });

                // Sincronizar la visibilidad inicial con el estado reactivo
                const isInitiallyCollapsed = this.isCollapsedState[el.id];
                if (isInitiallyCollapsed) {
                    this.collapseInstances[el.id].hide();
                } else {
                    this.collapseInstances[el.id].show();
                }
            });
        },

        toggleCollapse(id) {
            // Alterna el estado de colapso usando la instancia de Bootstrap Collapse
            if (this.collapseInstances[id]) {
                const isCurrentlyCollapsed = document.getElementById(id).classList.contains("show");

                if (isCurrentlyCollapsed) {
                    this.collapseInstances[id].hide();
                } else {
                    this.collapseInstances[id].show();
                }
                // Actualiza el estado reactivo de si está colapsado
                this.isCollapsedState[id] = !isCurrentlyCollapsed;
            }
        },

        isCollapsed(id) {
            // Retorna el estado actual de si un nav está colapsado o no
            return this.isCollapsedState[id];
        }
    },    
    
    beforeUnmount() {
        eventBus.off('toggle-sidebar', this.setSidebar);
    },
};
</script>

<style>

.rotated {
    transform: rotate(180deg) !important;
    transition: transform 0.3s ease !important;
}

/* Sidebar base */
.sidebar {
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  width: 300px;
  z-index: 996;
  transition: all 0.3s;
  padding: 20px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #aab7cf transparent;
  box-shadow: 0px 0px 20px rgba(1, 41, 112, 0.1);
  background-color: #fff;
}

.sidebar.open {
  left: 0;
}

/* Ocultar sidebar en móviles por defecto */
@media (max-width: 1199px) {
  .sidebar {
    left: -300px;
  }

  body.toggle-sidebar .sidebar {
    left: 0;
  }

  body.toggle-sidebar #main,
  body.toggle-sidebar #footer {
    margin-left: 0; /* no mover el contenido en móvil */
  }
}

/* En escritorio: mostrar sidebar y empujar contenido */
@media (min-width: 1200px) {
  #main,
  #footer {
    margin-left: 300px;
    transition: margin-left 0.3s;
  }

  body.toggle-sidebar .sidebar {
    left: -300px;
  }

  body.toggle-sidebar #main,
  body.toggle-sidebar #footer {
    margin-left: 0;
  }
}

.icon-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

</style>